import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal, ConfigProvider, Divider } from "antd";

export default function InventoryConfirmModal({
  open = false,
  title = "Confirm",
  message = "",
  onConfirm = () => {},
  onCancel = () => {},
}) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            // defaultHoverBorderColor: "#FFD700",
            // defaultHoverColor: "#000000",
            // fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        open={open}
        onOk={onConfirm}
        onCancel={onCancel}
        okText="Okay"
        cancelText="Close"
        centered
        width={600}
        okButtonProps={{
          style: { backgroundColor: "#2EC114", color: "white", fontWeight: 700 },
        }}
        cancelButtonProps={{
          style: { backgroundColor: "#FA6060", color: "white", fontWeight: 700 },
        }}
      >
        <div className="flex flex-col font-uregular">
          <div className="flex items-center gap-2 mb-4">
            <ExclamationCircleOutlined style={{ color: "red", fontSize: "24px" }} />
            <div className="text-2xl font-ubold ml-3">{title}</div>
          </div>
          <Divider />
          {message && <div className="text-sm font-p_medium text-black">{message}</div>}
          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}
